// extracted by mini-css-extract-plugin
export default {"DocPreview":"DocGenPreview_DocPreview__dvDG5","header":"DocGenPreview_header__cm80R","name":"DocGenPreview_name__aLcGv"};